<template>
    <div class="modal-goodslist">
        <div class="modal">
            <div class="modal-header">
                <div style="padding: 6px;">网关绑定</div>
                <button type="button" class="btn-close" @click="closeSelf">关闭</button>
            </div>
            <div class="modal-body">

                <el-form :model="addForm" :rules="rules" ref="addForm">
                    <div>
                        <el-row>
                            <el-col :span="12" class="item">
                                <el-form-item label="网关号" required prop="gatewayId">
                                    <el-input v-model="addForm.gatewayId" placeholder="请输入网关号"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12" class="item">
                                <el-form-item label="绑定老人" required prop="userName">
                                    <el-input v-model="addForm.userName" placeholder="请选择绑定老人" disabled>
                                        <el-button slot="append" icon="el-icon-search" @click="getElderly"></el-button>
                                    </el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </div>

                </el-form>

            </div>
            <div class="modal-footer">
                <el-button :loading="loading" type="primary" @click="confirm('addForm')">添加</el-button>
            </div>
        </div>
        <GetElderly ref="myGetElderly" v-show="showModalGetElderly" v-on:closeElderly="showModalGetElderly=false"  v-on:setElderly="setElderly"></GetElderly>
    </div>
</template>

<script>

    import {timeStr} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";

    import GetElderly from "@/views/Elderly/Comm/ElderlyGov";

    export default {
        name: 'Add',
        data() {
            return {
                loading: false,
                showModalGetElderly: false,
                addForm:{
                    timeStr:timeStr,
                    sign:'',
                    plateform:'shop',
                    phone:'',
                    userCode:'',
                    userName:'',
                    governmentCode:'',
                    gatewayId:'',
                    idCard:''
                },
                rules:{
                    gatewayId:[
                        { required: true, message: '请输入网关号', trigger: 'blur' },
                    ],
                    userName:[
                        { required: true, message: '请选择老人', trigger: 'blur' }
                    ]
                }


            }
        },
        components: {GetElderly},
        methods: {
            init(){
                this.$refs.addForm.resetFields();
            },
            closeSelf() {
                this.$emit("closeAdd");
            },
            getElderly(){
                this.showModalGetElderly = !this.showModalGetElderly;
                this.$refs.myGetElderly.init();
            },
            setElderly(row){
                //console.log(row)
                this.addForm.userCode=row.userCode;
                this.addForm.phone = row.phone;
                this.addForm.userName = row.name;
                this.addForm.idCard = row.idCard;
                this.addForm.governmentCode = row.governmentCode;
            },
            confirm(addForm){
                this.$refs[addForm].validate((valid) => {
                    if(valid){
                        this.addSubmit();
                    }else {
                        console.log('error submit!!');
                        return false;
                    }
                })

            },

            addSubmit(){

                if(this.loading){
                    return;
                }else{
                    this.loading = true;
                }

                this.addForm.sign = hex_md5("timeStr=" + timeStr + "&key="+this.$signKey);
                this.$axios({
                    method: 'post',
                    url: this.$deviceUrl+"DeviceYjgateway/Add2",
                    data: this.addForm
                }).then(
                    (response) => {
                        this.loading = false;
                        if (response.data.error == 0) {
                            this.$emit("closeAdd");
                            this.$emit("getList");
                        }else if(response.data.error == 1){
                            this.$message.error(response.data.message)
                        }
                    }
                )
            },


        }
    }


</script>





<style lang="scss" scoped>

    .modal-goodslist {
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        background-color: rgba(0,0,0,.3);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 99;

        .modal {
            background-color: #fff;
            box-shadow:   0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
            overflow-x:auto;
            display: flex;
            flex-direction: column;
            border-radius: 10px;
            width: 600px;

            .modal-header {
                border-bottom: 1px solid #eee;
                color: #313131;
                justify-content: space-between;
                padding: 10px;
                display: flex;
            }
            .modal-body {
                position: relative;
                padding: 20px 0px;
                z-index: 99;
                height: 100%;
                /deep/ .el-input.is-disabled .el-input__inner {
                    background: white;
                    color:  #606266;
                }
            }
            .modal-footer {
                border-top: 1px solid #eee;
                justify-content: flex-end;
                padding: 15px;
                display: flex;
            }


        }

    }


    .btn-close, .btn-confirm {
        border-radius: 8px;
        margin-left:16px;
        width:56px;
        height: 36px;
        border:none;
        cursor: pointer;
    }
    .btn-close {
        color: #313131;
        background-color:transparent;
    }



    .row{
        padding: 10px 0px;
    }
    .item{
        padding: 0px 20px;
    }
    .label{
        padding: 5px 0px;
    }


</style>
